<template>
  <dashboard-content>
    <template v-slot:actions>
      <quota-usage
        v-if="isQuotaLoaded && canReviewContent"
        :current="quota.current"
        :limit="quota.limit"
        :packages="quota.packages"
      />
    </template>

    <blocked-review-banner v-if="!canReviewContent && isEmpty"/>

    <div>
      <the-posts
        :posts="posts"
        :loaded="isPostsLoaded"
        approvable
        rejectable
      />
    </div>

    <template v-if="isEmpty && canReviewContent">
      <div
        class="card p-4 flex flex-col justify-center items-center mx-auto h-72 w-full lg:w-3/4"
      >
        <div
          class="text-lg text-center leading-relaxed"
          v-html="hasNoPostMessage"
        ></div>
        <div class="text-sm text-center mt-12">
          <base-you-need-help-message />
        </div>
      </div>
    </template>
  </dashboard-content>
</template>

<script lang="ts">
import { computed, defineComponent, onMounted, unref } from 'vue'
import { usePaidQuota } from '@/composables/profile/useQuota'
import { useReviewPosts } from '@/api/publications/usePosts'
import DashboardContent from '@/components/dashboard/DashboardContent.vue'
import QuotaUsage from '@/components/posts/QuotaUsage.vue'
import ThePosts from '@/components/posts/ThePosts.vue'
import { useProfile } from '@/composables/profile/useProfile'
import BlockedReviewBanner from '@/components/posts/blockedReviewBanner.vue'
import { useI18n } from 'vue-i18n'
import BaseYouNeedHelpMessage from '@/components/base/BaseYouNeedHelpMessage.vue'

export default defineComponent({
  components: {
    DashboardContent,
    QuotaUsage,
    ThePosts,
    BlockedReviewBanner,
    BaseYouNeedHelpMessage
},
  setup () {
    const { t } = useI18n()
    const {
      isQuotaLoaded,
      quota,
      birtday
    } = usePaidQuota()

    const {
      isFreeTrial,
      lockAccess,
      userRules
    } = useProfile()

    const {
      isPostsLoaded,
      posts,
      fetchPosts
    } = useReviewPosts()

    const isEmpty = computed(() => {
      return unref(isPostsLoaded) && unref(posts).length === 0
    })

    const hasNoPostMessage = computed(() => {
      const messages = {
        creating: t('state.reviews.creating_posts_message-html'),
        alreadUsed: t('state.reviews.alread_review_posts_message-html', { birtday }),
        noContent: t('state.reviews.no_posts_message-html', { birtday })
      }
      if (unref(quota).limit === 0) {
        return messages.noContent
      } else if (unref(quota).current < unref(quota).limit) {
        return messages.creating
      }
      return messages.alreadUsed
    })

    const canReviewContent = computed(() => {
      return !lockAccess || userRules.value.canReviewContent
    })

    onMounted(async () => {
      await fetchPosts()
    })

    return {
      isPostsLoaded,
      isQuotaLoaded,
      isEmpty,
      isFreeTrial,
      canReviewContent,
      hasNoPostMessage,
      posts,
      quota
    }
  }
})
</script>
